import { useTranslation } from "react-i18next";
import Button from "shared/UI/Buttons/Button";
import { Modal } from "shared/UI/Modal/Modal";

export const WhatsAppTermsModal = ({
  isSending,
  handleClickContinue,
  handleClickCancel,
}: {
  isSending?: boolean;
  handleClickContinue: () => void;
  handleClickCancel: () => void;
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: "support.whatsApp.notice" });
  return (
    <Modal width="xs">
      <div data-testid="feedback-modal" className="relative p-6 text-center">
        <div className="space-y-4">
          <h2>{t("title")}</h2>
          <p>
            {t("description")}
            <a href={t("terms.link") as string} target="_blank" rel="noreferrer">
              {t("terms.label")}
            </a>
            {" and "}
            <a href={t("privacy.link")} target="_blank" rel="noreferrer">
              {t("privacy.label")}
            </a>
          </p>
          <p>{t("disclaimer")}</p>
          <p>{t("agree")}</p>
          <div className="space-y-3 pt-4">
            <Button text={isSending ? t("sending") : t("continue")} onClick={handleClickContinue} disabled={isSending} />
            <Button variant="text" text={t("cancel")} onClick={handleClickCancel} disabled={isSending} />
          </div>
        </div>
      </div>
    </Modal>
  );
};
